import Http from '../http'

export default {

  index() {
    return Http.get(`/users`)
  },


  create(user){
    return Http.post(`/users`, {user: {
      ...user,
      password: '9876543210',
      password_confirmation: '9876543210',
    }})
  },

  update(user){
    return Http.put(`/users/${user.id}`, {
      user: {
        ...user,
      },
    });
  },

  show(id) {
    return Http.get(`/users/${id}`);
  },

  delete(id){
    return Http.delete(`/users/${id}`)
  }

}
